
import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import RichText from '@common/RichText';

import * as styles from './core-values-grid.module.scss';

const CoreValuesGrid = ({ data }) => {
  const {
    titleAlignment,
    text,
    imagePosition,
    imagePositionTop,
    imagePositionTopLg,
    images,
    links,
    topMargin,
    bottomMargin,
    bgColour,
    bgNoPadding,
    bgFullwidth
  } = data;
  return (
    <Section spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
      [`bg-${bgColour}`]: bgColour,
      'py-5': bgColour && !bgNoPadding,
      'container card': !bgFullwidth
    })}>
      <Container>
        <Row className={clsx(`d-flex flex-column align-items-center`, {
          'flex-md-row-reverse': imagePosition === 'Left' && !imagePositionTopLg,
          'flex-md-row': imagePosition === 'Right' && !imagePositionTopLg,
          'flex-column-reverse': imagePositionTop || imagePositionTopLg,
          'justify-content-center': (!images || !links) && titleAlignment === 'Center'
        })}>
          <div className={clsx(styles.brandColorStyle)}>
            {text &&
              <RichText
                json={text}
                h1='mb-3'
                h2='mb-3 text-center'
                p='mb-0 fs-32 fw-medium'
                a='fs-16'
              />
            }
          </div>
        </Row>
      </Container>
    </Section>
  )
}

export default CoreValuesGrid
